import { hasDoneTodayJst, markDoneTodayJst } from "~/utils/oncePerDay";

/** localStorage のキー: 起動キャンペーン動画を最後に表示した日付（JST 'YYYY-MM-DD'） */
const LAUNCH_CAMPAIGN_INTRO_DATE_KEY = "lastLaunchCampaignIntroShownDate";

/**
 * 当日（JST）まだ起動キャンペーン動画を表示していなければ true。
 * localStorage + JST日付で「1日1回」を表現する（アプリ起動ごとではなく、その日の最初の起動時のみ）。
 */
export const shouldShowLaunchCampaignIntro = (): boolean =>
  !hasDoneTodayJst(LAUNCH_CAMPAIGN_INTRO_DATE_KEY);

/**
 * 起動キャンペーン動画を当日表示済みとして localStorage に記録する。
 */
export const markLaunchCampaignIntroShown = (): void =>
  markDoneTodayJst(LAUNCH_CAMPAIGN_INTRO_DATE_KEY);
